// extracted by mini-css-extract-plugin
export default {"button":"Button_button__tJ3hL","primary":"Button_primary__dPFrL","ghost":"Button_ghost__28zzE","wide":"Button_wide__3eUTT","small":"Button_small__oXKlZ"};